import { rem } from 'polished'
import styled from 'styled-components'

import { type ISortableTagsProps } from '../SortableTags'

export const SortableTagsStyled = styled.div<Partial<ISortableTagsProps>>`
  font-size: ${rem(16)};
  overflow: auto;
`
